"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var NewsletterPopup = /*#__PURE__*/function () {
  function NewsletterPopup(component) {
    (0, _classCallCheck2["default"])(this, NewsletterPopup);
    this.dom = {
      $component: component,
      $input: component.querySelector('.js-klaviyo-newsletter-form-email'),
      $close: component.querySelector('.js-newsletter-popup-close'),
      $forceClose: component.querySelector('.js-newsletter-popup-force-close')
    }, this.state = {
      openLink: '#newsletter-popup',
      openDuration: 250,
      closeDuration: 500,
      animating: false,
      scrollTarget: window.innerHeight / 2,
      active: component.classList.contains('is-active'),
      activeClass: 'is-active',
      timeout: 0,
      cookie: {
        initial: _jsCookie["default"].get('LePetitTrouNewsletterPoupShown'),
        name: 'LePetitTrouNewsletterPoupShown',
        value: true
      }
    };
    this.keydownHandler = this.onKeydown.bind(this);
    this.clickHandler = this.onClick.bind(this);
    this.closeHandler = this.close.bind(this);
    this.forceCloseHandler = this.forceClose.bind(this);
    this.scrollHandler = this.onScroll.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(NewsletterPopup, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : mount', this);
      document.addEventListener('keydown', this.keydownHandler);
      document.addEventListener('click', this.clickHandler);
      dom.$close.addEventListener('click', this.closeHandler);
      dom.$forceClose.addEventListener('click', this.forceCloseHandler);
      this.init();
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : unmount', this);
      document.removeEventListener('keydown', this.keydownHandler);
      document.removeEventListener('click', this.clickHandler);
      dom.$close.removeEventListener('click', this.closeHandler);
      dom.$forceClose.removeEventListener('click', this.forceCloseHandler);

      if (!state.cookie.initial) {
        document.removeEventListener('scroll', this.scrollHandler, true);
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;

      var state = this.state;
      console.log('NewsletterPopup : init', this);

      if (!state.cookie.initial) {
        setTimeout(function () {
          _this.setScrollListener();
        }, state.timeout);
      } else {
        this.close();
      }
    }
  }, {
    key: "setScrollListener",
    value: function setScrollListener() {
      document.addEventListener('scroll', this.scrollHandler, true);
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var state = this.state;
      event.preventDefault();
      event.stopPropagation();
      console.log('NewsletterPopup : toggle', this);

      if (state.active) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('NewsletterPopup : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.active && escape) {
        this.close();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var state = this.state;
      console.log('NewsletterPopup : onClick', this, event);

      if (event.target.href && ~event.target.href.indexOf(state.openLink)) {
        this.toggle(event);
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll(event) {
      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : onScroll', this, event);
      var scrollY = window.scrollY;

      if (!state.active && scrollY > state.scrollTarget) {
        if (!_jsCookie["default"].get('LePetitTrouNewsletterPoupShown')) {
          this.open();
        }
      }
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : open', this);

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', 'false');
        dom.$component.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
        }, 25);
        setTimeout(function () {
          state.active = true;
          state.animating = false;

          _this2.setFocus();
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;

      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : close', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', 'true');
          dom.$component.setAttribute('aria-expanded', 'false');
          state.active = false;
          state.animating = false;

          _this3.setCookie();
        }, state.closeDuration);
      }
    }
  }, {
    key: "forceClose",
    value: function forceClose(event) {
      var dom = this.dom,
          state = this.state;
      console.log('NewsletterPopup : forceClose', this, event);

      if (event.target === dom.$forceClose) {
        this.close();
      }
    }
  }, {
    key: "setCookie",
    value: function setCookie() {
      var state = this.state;
      console.log('NewsletterPopup : setCookie', this);

      _jsCookie["default"].set(state.cookie.name, state.cookie.value, {
        path: '/'
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      var dom = this.dom;
      console.log('NewsletterPopup : setFocus', this);
      dom.$input.focus();
    }
  }]);
  return NewsletterPopup;
}();

exports["default"] = NewsletterPopup;